// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2gTb9","notes":"Notes_notes__1qDa6"};